import { useMemo } from 'react'

import { Department } from '../../../../entities/Department/Department'
import useCheckPermission from '../../../../helpers/hooks/useCheckPermission'

const useCheckDepartmentsPermissions = (currentUserDepartments: Department[], userDepartments: Department[]): boolean => {
    const canAssignAssignedDepartments = useCheckPermission('assign-assigned-departments')
    const departments = userDepartments.filter(department => ! department.deletedAt)
    const currentUserDepartmentIds = useMemo(() => currentUserDepartments.map(department => department.id), [currentUserDepartments])
    const userDepartmentIds = useMemo(() => departments.map(department => department.id), [departments])
    const canManageAllDepartments = useMemo(
        () => userDepartmentIds.every(id => currentUserDepartmentIds.includes(id)),
        [currentUserDepartmentIds, userDepartmentIds],
    )

    if (departments.length === 0) {
        return true
    }

    if (canAssignAssignedDepartments) {
        return true
    }

    return canManageAllDepartments
}

export default useCheckDepartmentsPermissions
